import { render } from "./NewTransactionCardTable.vue?vue&type=template&id=039cdb15"
import script from "./NewTransactionCardTable.vue?vue&type=script&lang=js"
export * from "./NewTransactionCardTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__